import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { on } from "@ember/modifier";
import { action } from "@ember/object";
import { service } from "@ember/service";
import Wrapper from "discourse/components/form-template-field/wrapper";
import { ajax } from "discourse/lib/ajax";
import { popupAjaxError } from "discourse/lib/ajax-error";
import DButton from "discourse/ui-kit/d-button";
import DHighlightedCode from "discourse/ui-kit/d-highlighted-code";
import DModal from "discourse/ui-kit/d-modal";
import DModalCancel from "discourse/ui-kit/d-modal-cancel";
import DToggleSwitch from "discourse/ui-kit/d-toggle-switch";
import { i18n } from "discourse-i18n";

export default class CustomizeFormTemplateViewModal extends Component {
  @service router;
  @service dialog;

  @tracked showPreview = false;

  @action
  togglePreview() {
    this.showPreview = !this.showPreview;
  }

  @action
  editTemplate() {
    this.router.transitionTo(
      "adminCustomizeFormTemplates.edit",
      this.args.model
    );
  }

  @action
  deleteTemplate() {
    return this.dialog.yesNoConfirm({
      message: i18n("admin.form_templates.delete_confirm", {
        template_name: this.args.model.name,
      }),
      didConfirm: () => {
        ajax(`/admin/customize/form-templates/${this.args.model.id}.json`, {
          type: "DELETE",
        })
          .then(() => {
            this.args.refreshModel();
          })
          .catch(popupAjaxError);
      },
    });
  }

  <template>
    <DModal
      class="customize-form-template-view-modal"
      @closeModal={{@closeModal}}
      @title={{@model.name}}
    >
      <:body>
        <div class="control-group">
          <DToggleSwitch
            class="form-templates__preview-toggle"
            @label="admin.form_templates.view_template.toggle_preview"
            @state={{this.showPreview}}
            {{on "click" this.togglePreview}}
          />
        </div>
        {{#if this.showPreview}}
          <Wrapper @id={{@model.id}} />
        {{else}}
          <DHighlightedCode @code={{@model.template}} @lang="yaml" />
        {{/if}}
      </:body>

      <:footer>
        <DButton
          class="btn-primary"
          @action={{this.editTemplate}}
          @icon="pencil"
          @label="admin.form_templates.view_template.edit"
        />
        <DModalCancel @close={{@closeModal}} />
        <DButton
          class="btn-danger"
          @action={{this.deleteTemplate}}
          @icon="trash-can"
          @label="admin.form_templates.view_template.delete"
        />
      </:footer>
    </DModal>
  </template>
}
